import React, { useEffect, useState, useRef } from 'react';
import { scaleBanner } from '@/client/utils/bannerResizer';

interface BannerProps {
  position: string;
  type: string;
  enableResizer?: boolean;
}

const BannerListItem: React.FC<BannerProps> = ({ position, type, enableResizer = false }) => {
  const [mounted, setMounted] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted || !enableResizer) return;

    const container = containerRef.current;
    const wrapper = wrapperRef.current;
    if (!container || !wrapper) return;

    const applyScaling = () => scaleBanner(container, wrapper);

    const observer = new MutationObserver(applyScaling);
    observer.observe(container, { childList: true, subtree: true });

    window.addEventListener('resize', applyScaling);
    applyScaling();

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', applyScaling);
    };
  }, [mounted, enableResizer]);

  if (!mounted) {
    return null;
  }

  return (
    <div ref={wrapperRef} className={`hz-Banner hz-Banner--${type}`}>
      <div ref={containerRef} id={`banner-${position}`} />
    </div>
  );
};

export default BannerListItem;
